/* eslint-disable no-unused-vars */
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Ad from 'models/business/Ad';
import Market from 'models/business/Market';
import EmptyBar from 'components/Common/EmptyBar';
import CardBar from 'components/Common/CardBar';
import API from 'api';
import MarketButton from './MarketButton';
import Styles from './index.module.css';

function SelectMarket({
  ad,
  onChangeAd,
  active,
  onSetActive,
}) {
  const [markets, setMarkets] = useState([]);

  const getMarketList = async () => {
    const result = await API.mall.getMallList();
    if (result.error) {
      alert(result.error.errorMsg);
      return;
    }
    setMarkets((result.resultData || []).map((m) => new Market(m)));
  };

  const handleChangeMarket = (market) => {
    const newAd = ad.clone();
    newAd.marketId = market.id;
    newAd.injectMarket(market);
    onChangeAd(newAd);
  };

  useEffect(() => {
    getMarketList();
  }, []);

  useEffect(() => {
    if (!markets.length || !active || !!ad.market.id) return;
    handleChangeMarket(markets[0]);
  }, [markets, ad, active]);

  const renderEmpty = useMemo(() => (
    <div className={Styles.buttonContainer}>
      {
          markets.map((market) => (
            <div
              className={Styles.buttonItem}
              key={`empty-market-${market.id}`}
            >
              <EmptyBar>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    paddingLeft: 18,
                  }}
                >
                  <div
                    className={Styles.emptyBarText}
                  >
                    {market.name}
                  </div>
                </div>
              </EmptyBar>
            </div>
          ))
        }
    </div>
  ));

  const renderSelect = useMemo(() => (
    <div className={Styles.buttonContainer}>
      {
        markets.map((market) => (
          <MarketButton
            key={`render-market-button-${market.id}`}
            market={market}
            onClick={() => {
              handleChangeMarket(market);
              onSetActive();
            }}
            selected={market.id === ad.market.id}
            expanded={active}
          />
        ))
      }
    </div>
  ));

  return (
    <div>
      <div
        className={classNames(
          Styles.titleText, { [Styles.titleTextExpanded]: active },
        )}
      >
        選擇欲廣告賣場
      </div>
      {!ad.platform && <div className={Styles.emptyBar} />}
      {!!ad.platform && renderSelect}
    </div>
  );
}

SelectMarket.propTypes = {
  active: PropTypes.bool,
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
  onSetActive: PropTypes.func,
};

SelectMarket.defaultProps = {
  ad: new Ad(),
  onChangeAd: () => {},
  onSetActive: () => {},
  active: true,
};

export default SelectMarket;
